
import { ApiFetch } from '../../../shared/utils/fetch';
import type { Post, PaginatedResponse, CreatePostInput, UpdatePostInput, ListParams } from '../types';
import { toQuery } from '../utils';

export const postsApi = {
  fetchPosts: (params?: ListParams) => ApiFetch.get<PaginatedResponse<Post>>(`/posts${toQuery(params)}`),
  fetchPost: (id: string) => ApiFetch.get<Post>(`/posts/${id}`),
  createPost: (data: CreatePostInput) => ApiFetch.post<Post>('/posts', data),
  updatePost: (id: string, data: UpdatePostInput) => ApiFetch.put<Post>(`/posts/${id}`, data),
  deletePost: (id: string) => ApiFetch.del<void>(`/posts/${id}`),
  publishPost: (id: string) => ApiFetch.post<Post>(`/posts/${id}/publish`, {}),
  schedulePost: (id: string, date: string) => ApiFetch.post<Post>(`/posts/${id}/schedule`, { scheduledAt: date }),
  unpublishPost: (id: string) => ApiFetch.post<Post>(`/posts/${id}/unpublish`, {}),
  duplicatePost: (id: string) => ApiFetch.post<Post>(`/posts/${id}/duplicate`, {}),
};
